import * as XLSX from "xlsx";
import moment from "moment";

// Builds formatted Excel files: readable headers, set column widths, real
// date cells (so Excel never shows ####) and a filter on the header row.
//
// sheets: [{ name, columns: [{ header, width, type?: "date"|"datetime"|"number", value: (row) => any }], rows }]

// 'YYYY-MM-DD' → local-midnight Date, so Excel shows exactly that date
export const excelDate = (value) => {
  if (!value) return null;
  const m = moment(String(value).slice(0, 10), "YYYY-MM-DD", true);
  return m.isValid() ? new Date(m.year(), m.month(), m.date()) : null;
};

// Timestamp (ISO/UTC from the API) → local Date for an Excel date-time cell
export const excelDateTime = (value) => (value ? moment(value).toDate() : null);

const buildSheet = (columns, rows) => {
  const aoa = [
    columns.map((c) => c.header),
    ...rows.map((r) =>
      columns.map((c) => {
        const v = c.value(r);
        return v === undefined || v === null ? "" : v;
      }),
    ),
  ];
  const ws = XLSX.utils.aoa_to_sheet(aoa, { dateNF: "dd-mmm-yyyy" });
  ws["!cols"] = columns.map((c) => ({ wch: c.width || 14 }));
  columns.forEach((c, ci) => {
    if (c.type !== "datetime") return;
    for (let ri = 1; ri < aoa.length; ri++) {
      const cell = ws[XLSX.utils.encode_cell({ r: ri, c: ci })];
      if (cell && cell.t === "n") cell.z = "dd-mmm-yyyy hh:mm";
    }
  });
  if (aoa.length > 1) {
    ws["!autofilter"] = {
      ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: aoa.length - 1, c: columns.length - 1 } }),
    };
  }
  return ws;
};

export const downloadWorkbook = (filename, sheets) => {
  const wb = XLSX.utils.book_new();
  sheets.forEach((s) => XLSX.utils.book_append_sheet(wb, buildSheet(s.columns, s.rows), s.name.slice(0, 31)));
  XLSX.writeFile(wb, filename);
};
